var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "24px",
    viewBox: "0 0 30 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "41F2612B-3C8F-49F7-A4F1-19D0BE0928C0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.070588 0 0 0 0 0.415686 0 0 0 0 0.541176 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13.0_My-Library_11.1",
    transform: "translate(-280.000000, -302.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder",
    transform: "translate(260.000000, 267.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4117647,5.92007407 L13.5882353,5.92007407 L11.4352941,3.3422963 C11.3628676,3.25459259 11.2543382,3.20540741 11.1411765,3.20878264 L2.40882353,3.20878264 C1.07558824,3.21874074 0,4.3102963 0,5.65340741 L0,21.5082222 C0.00161764706,22.8559259 1.08573529,23.9480741 2.42352941,23.9497037 L24.4117647,23.9497037 C25.7495588,23.9480741 26.8336765,22.8559259 26.8352941,21.5082222 L26.8352941,8.36155556 C26.8336765,7.01385185 25.7495588,5.9217037 24.4117647,5.92007407 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5911765,2.76155556 L16.7647059,2.76155556 L14.6117647,0.183777778 C14.5393382,0.0960740741 14.4308088,0.0468888889 14.3176471,0.0502641207 L5.58823529,0.0502641207 C4.37852941,0.0524444444 3.35558824,0.952740741 3.19117647,2.16007407 L11.1529412,2.16007407 C11.5704412,2.15903704 11.9668382,2.34466667 12.2352941,2.66674074 L14.0735294,4.86822222 L24.4117647,4.86822222 C26.3238971,4.87148148 27.8732353,6.4322963 27.8764706,8.35859259 L27.8764706,20.7674815 C29.0888235,20.6151111 29.9990441,19.5775556 30,18.3467407 L30,5.20007407 C29.9968382,3.85925926 28.9220588,2.77133333 27.5911765,2.76155556 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/FolderIcon.ecc22a45d621bcd32eeb67a8d9f3fbfd.svg";
export { ForwardRef as ReactComponent };